import * as React from 'react'
import { useRef, useState } from 'react'
import css from './MemePage.module.sass'
import { Conversation, makeConversationStore } from './Conversation';
import domtoimage from 'dom-to-image'
import { saveAs } from 'file-saver';
import ContentEditable from 'react-contenteditable';
import { MoveIconMap } from './MoveIcons';
import { observer } from 'mobx-react-lite';

const ContentEditablePlain: React.FC<{defaultHtml: string}> = ({ defaultHtml }) => {
	const [content, setContent] = useState(defaultHtml)
	return <ContentEditable html={content} onChange={e => setContent(e.target.value)}/>
}

export const MemePage: React.FC = observer(() => {
	const conversationRef = useRef<HTMLDivElement | null>()
	const [conversation] = useState(makeConversationStore([
		{ from: 'sender', content: 'sugma', annotation: MoveIconMap.book },
		{ from: 'recipient', content: "what's sugma", annotation: MoveIconMap.blunder }
	]))
	const [name, setName] = useState('Name')

	async function exportToPng() {
		const svg = await domtoimage.toPng(conversationRef.current!!, {
			// @ts-ignore
			dpi: 96 * 2
		})
		saveAs(svg, 'meme.png')
	}

	let transcription = `**Image Transcription: Texting meme with chess.com annotations**\n`
	const realName = name.replace('<br>', '')
	if (realName !== '') {
		transcription += `Recipient: ${realName}\n`
	}
	transcription += '\n'

	conversation.forEach(m => {
		const from = m.from === 'sender' ? 'Sender' : 'Recipient'
		const content = m.content.replace('<br>', '')
		const annotationName = m.annotation?.name
		const annotation = annotationName != null ? `*[${annotationName}]*` : ''
		transcription += `${from}: ${content} ${annotation}\n\n`
	})

	transcription = transcription.trim()


	return <div className={css.main}>
		<div>
			<div className={[css.instructions, "content"].join(' ')}>
				<h1 className={"title"}>Usage Instructions</h1>
				<ul>
					<li>Hover your mouse underneath the latest message and start typing to add a new message.</li>
					<li>Left on the chess.com annotation icon to change it. Right click to remove.</li>
					<li>Click on a message and start typing to change it's contents</li>
					<li>Click on the recipient name, time, or battery, to change their contents</li>
					<li>Press the 'Export' button to produce a PNG image</li>
					<li>Use the Image Transcription on the right with your post to aid people using screen readers!</li>
				</ul>
			</div>

		</div>
		<div>
			<div className={css.meme} ref={r => conversationRef.current = r}>
				<div className={css.header2}>
					<h2>No Signal</h2>
					<h2><ContentEditablePlain defaultHtml={'4:20 AM'}/></h2>
					<h2><ContentEditablePlain defaultHtml={`${Math.floor(Math.random() * 100 + 1)}%`}/></h2>
				</div>
				<div className={css.header1}>
					<h2>❮ Messages</h2>
					<h2><ContentEditable html={name} onChange={e => setName(e.target.value)}/></h2>
					<h2>Details</h2>
				</div>
				<div className={css.conversation}>
					<Conversation store={conversation}/>
				</div>
				<div className={css.footer}>
					<ContentEditablePlain defaultHtml={'Send Message'}/>
				</div>
			</div>
		</div>
		<div className={css.exportOptions}>
			<div className={css.transcription}>
				<p>{transcription}</p>
			</div>
			<button
				className={'button is-primary'}
				onClick={() => exportToPng()}
			>Export</button>
		</div>
	</div>
})